export default "__VITE_ASSET__8LRMK$YQ__"